import { Container } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { t } from 'i18next';
import { PiKey, PiSignIn } from 'react-icons/pi';
import { IProviderSftpConnectionResponse } from 'services/providers/types';

const SftpKyesTab = () => {
  const { values, status }: IFormikContextType<IProviderSftpConnectionResponse> =
    useFormikContext<IProviderSftpConnectionResponse>();


  return (
    <div className='flex flex-col self-start w-full max-w-[370px] gap-4'>
      <Container>
        <Container.Header
          title={
            <>
              <PiSignIn /> {t('provider.ftp.passes')}
            </>
          }
        />
        <Container.Content>
          <FormInput.Text name='login' label={t('input.label.login')} />
          <FormInput.Text name='password' label={t('input.label.password')} />
        </Container.Content>
      </Container>
      <Container>
        <Container.Header
          title={
            <>
              <PiKey /> {t('provider.ftp.keys')}
            </>
          }
        />
        <Container.Content>
          <FormInput.Text name='keyPrint' label={t('input.label.keyPrint')} />
          <FormInput.Text
            name='keyPassphrase'
            label={t('input.label.keyPassphrase')}
          />
          <FormInput.Text name='keyPath' label={t('input.label.keyPath')} />
          <FormInput.Text
            name='sshHostKeyPolicyId'
            label={t('input.label.sshHostKeyPolicyId')}
          />
        </Container.Content>
      </Container>
    </div>
  );
};

export default SftpKyesTab;
